import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ApplyTripApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'apply-trip'
  }

}